<dx-data-grid
  [dataSource]="dataSource"
  [showBorders]="true"
  [focusedRowEnabled]="false"
  [columnAutoWidth]="true"
  [columnHidingEnabled]="false"
  [showColumnLines]="true"
  [showRowLines]="true"
  [rowAlternationEnabled]="true"
  (onRowDblClick)="goToConsegna($event)"
  >

  <dxo-editing
    mode="popup"
    [allowAdding]="false"
    [allowUpdating]="false"
    [allowDeleting] ="false"
    [useIcons]="true">
  </dxo-editing>

  <dxo-paging [pageSize]="15"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
  <dxo-filter-row [visible]="false"></dxo-filter-row>
  <dxi-column
    dataField="id"
    [visible]= "false">
  </dxi-column>
  <dxi-column
    dataField="progr"
    [visible]= "false">
  </dxi-column>
  <dxi-column
    name="firmaDoc"
    [formItem]="{ visible: false }"
    [allowFiltering]="false"
    [allowSorting]="false" cellTemplate="firmaDocTemplate"
    width="30"
    caption="">
  </dxi-column>
  <dxi-column
    dataField="data"
    format="dd/MM/yyyy"
    dataType="date"
    width="80"
    [sortIndex]="1"
    sortOrder="desc">
  </dxi-column>
  <dxi-column
    dataField="qta"
    width="45">
  </dxi-column>
  <dxi-column
    dataField="idArticolo"
    caption="Articolo"
    >
    <dxo-lookup [dataSource]="listArticoli" valueExpr="id" displayExpr="descrizione" ></dxo-lookup>
  </dxi-column>
  <dxi-column
    dataField="idDipendente"
    caption="Dipendente">
    <dxo-lookup [dataSource]="listDip" valueExpr="id" displayExpr="nominativo" ></dxo-lookup>
  </dxi-column>

  <dxi-column
    dataField="cambio"
    dataType="boolean"
    [visible]="false">
  </dxi-column>
  <dxi-column
    dataField="dettagli"
    [visible]="false" >
  </dxi-column>
  <dxi-column
    dataField="firmato"
    dataType="boolean"
    [visible]="false">
  </dxi-column>

  <div *dxTemplate="let d of 'firmaDocTemplate'">
    @if (!d.data.firmato) {
      <i class="dx-icon-rename"
      (click)="firmaDocumento(d.data)" data-toggle="tooltip" data-placement="top" title="Firma documento"></i>
    }
  </div>


</dx-data-grid>